// extracted by mini-css-extract-plugin
module.exports = {"mxWrapper":"style_mxWrapper__PIHMa"};